import { CAMPAIGN_CONST } from "@/config/constants";

export const DIRECT_MAIL_CAMP_PROVIDER = {
  RRD: "RRD",
  MAIL_SHARK: "MAILSHARK",
};

export const DIRECT_MAIL_CAMPAIGN_TYPE = {
  EVERGREEN: CAMPAIGN_CONST.POSTCARD.TYPE.EVERGREEN,
  LIMITED: CAMPAIGN_CONST.POSTCARD.TYPE.LIMITED,
  NATIONAL_PLUS_UP: "national_plus_up",
};
